export default __webpack_public_path__ + "static/media/Print_Successful.2cb965b3.png";